<ion-content class="white-background safe-area-top white">

    <app-modal-header></app-modal-header>

    <div class="d-flex flex-column ion-justify-content-between">

        <div class="content-spacing px-lg">

            <div>
                <div class="ts-h4-sans">{{ 'Crea il tuo account' | translate }}</div>
                <div class="ts-caption pt-xsm">{{ 'Registrati e pubblica i tuoi contenuti' | translate }}</div>
            </div>

            <div>
                <app-user-profile-form #appUserProfile></app-user-profile-form>
            </div>

            <div class="pt-xl d-flex ion-align-items-center gap-2">
                <ion-checkbox [(ngModel)]="policyAccepted"></ion-checkbox>
                <div class="ts-caption">
                    {{ 'Dichiaro di aver letto e accettato' | translate }}
                    <span (click)="onViewPolicy()" class="link-apperance">Policy</span>
                </div>
            </div>

            <div class="w-100 pt-xl safe-area-bottom">
                <ion-button
                        [disabled]="appUserProfile.registerForm.invalid || registerProgress"
                        (click)="onRegister()" class="w-100 d-flex">
                    <ion-spinner *ngIf="registerProgress"
                                 class="mr-sm" name="crescent"></ion-spinner>
                    <span>{{ 'Registrati' | translate }}</span>
                </ion-button>

            </div>

        </div>

    </div>

</ion-content>
